import { MessagesListLoadingSelector } from 'features/MessagesList/MessagesListSlice';
import { LogsListLoadingSelector } from 'features/LogsList/LogsListSlice';
import { LibrariesLoadingSelector } from 'features/Libraries/LibrariesSlice';
import { useAppSelector } from 'hooks/useStore';
import './Loader.css';
import { UserLoadingSelector } from 'features/User/UserSlice';
import { UsersListLoadingSelector } from 'features/UsersList/UsersListSlice';
import { RequestsListLoadingSelector } from 'features/RequestsList/RequestsListSlice';
import { FavouritesListLoadingSelector } from 'features/FavouritesList/FavouritesListSlice';
import { LotsListLoadingSelector } from 'features/LotsList/LotsListSlice';
import { CreateComplexModalLoadingSelector } from 'features/CreateComplexModal/CreateComplexModalSlice';
import { CreateLotModalLoadingSelector } from 'features/CreateLotModal/CreateLotModalSlice';
import { CreateOrganizationModalLoadingSelector } from 'features/CreateOrganizationModal/CreateOrganizationModalSlice';

import { JSX } from 'react/jsx-runtime';
import { ConsultationsListLoadingSelector } from 'features/ConsultationsList/ConsultationsListSlice';
import { ComplexesListLoadingSelector } from 'features/ComplexesList/ComplexesListSlice';
import { OrganizationsListLoadingSelector } from 'features/OrganizationsList/OrganizationsListSlice';

const Loader = (): JSX.Element => {
	const userLoading = useAppSelector(UserLoadingSelector);
	const usersListLoading = useAppSelector(UsersListLoadingSelector);
	const messagesLoading = useAppSelector(MessagesListLoadingSelector);
	const librariesLoading = useAppSelector(LibrariesLoadingSelector);
	const logsListLoading = useAppSelector(LogsListLoadingSelector);
	const createLotModalLoading = useAppSelector(CreateLotModalLoadingSelector);
	const createComplexModalLoading = useAppSelector(CreateComplexModalLoadingSelector);
	const createOrganizationModalLoading = useAppSelector(CreateOrganizationModalLoadingSelector);
	const lotsListLoading = useAppSelector(LotsListLoadingSelector);
	const complexesListLoading = useAppSelector(ComplexesListLoadingSelector);
	const organizationsListLoading = useAppSelector(OrganizationsListLoadingSelector);
	const requestsListLoading = useAppSelector(RequestsListLoadingSelector);
	const favouritesListLoading = useAppSelector(FavouritesListLoadingSelector);
	const consultationsListLoading = useAppSelector(ConsultationsListLoadingSelector);

	return (
		<>
			{messagesLoading ||
			librariesLoading ||
			userLoading ||
			usersListLoading ||
			requestsListLoading ||
			lotsListLoading ||
			complexesListLoading ||
			createLotModalLoading ||
			createComplexModalLoading ||
			createOrganizationModalLoading ||
			favouritesListLoading ||
			consultationsListLoading ||
			organizationsListLoading ||
			logsListLoading ? (
				<div className="modal-backdrop">
					<span className="spinner"></span>
				</div>
			) : null}
		</>
	);
};

export default Loader;
